import React from "react";
import "./ContactLogo.css";

const StatusTrack = (props) => {
  var attachclasses = "";
  props.flag
    ? (attachclasses = "trackButton move_status")
    : (attachclasses = "trackButton");
  return (
    <>
      <button
        className={attachclasses}
        onClick={props.click}
        disabled={props.disableButton}
      >
        Track Transaction Status
      </button>
    </>
    // <img id="logo-contact" className={attachclasses} onClick={props.click} alt="Contact-US" src={require("assets/img/icons/contact-us.png")} />
  );
};

export default StatusTrack;
